import React from 'react';
import styles from './AdExitTime.module.scss';
import {If, Then} from "react-if";

import GenericDetail from '../genericDetail/GenericDetail';
import moment from 'moment';
import FlightTakeoffRoundedIcon from '@material-ui/icons/FlightTakeoffRounded';
import {ITicketDetailsWithTerms} from 'gui/components/editors/flightEditor/components/ticketDetailsForm';

interface IAdExitTimeProps {
  ticketDetails: Partial<ITicketDetailsWithTerms>;
}

const AdExitTime = (props: IAdExitTimeProps) => (
  <If
    condition={!!(props.ticketDetails.originTimeOfTakeOff && props.ticketDetails.originTimeOfLanding)}>
    <Then>
      {() =>
        <GenericDetail
          title="יציאה"
          icon={FlightTakeoffRoundedIcon}
        >
          <>
            <span
              className={styles.time}>{moment(props.ticketDetails.originTimeOfTakeOff).format('D MMM YYYY, HH:mm')}</span>
            <span>&nbsp;</span>
            <span className={styles.city}>{props.ticketDetails.originAirport.city}</span>
          </>
        </GenericDetail>
      }
    </Then>
  </If>
);

AdExitTime.defaultProps = {
  product: {},
};
export default AdExitTime;
